import { render, staticRenderFns } from "./MudarEtapa.vue?vue&type=template&id=a47821a4"
import script from "./MudarEtapa.vue?vue&type=script&lang=ts"
export * from "./MudarEtapa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports